export enum GameQueryKeys {
	GetGameList = 'game.getGameList',
	GetGameTypeList = 'game.getGameTypeList',
	GetGameProviderList = 'game.getGameProviderList',
}

export enum GameMutationKeys {
	UpdateGame = 'game.updateGame',
	UpdateGameType = 'game.updateGameType',
	UpdateGameProvider = 'game.updateGameProvider',
	CreateProviderBannerFileUrl = 'game.createProviderBannerFileUrl',
	CreateProviderLogoFileUrl = 'game.createProviderLogoFileUrl',
	UpdateGameTypeProviderGameType = 'game.updateGameTypeProviderGameType',
	BatchUpdateProviderPreset = 'game.batchUpdateProviderPreset',
	BatchUpdateGamePreset = 'game.batchUpdateGamePreset',
}
